const attachRecaptchaScript = () => {
  if (!window.grecaptcha) {
    const gRecaptchaScript = document.createElement('script')
    gRecaptchaScript.setAttribute(
      'src',
      `https://www.google.com/recaptcha/api.js?render=${
        process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY
      }`
    )
    document.head.appendChild(gRecaptchaScript)
  }
}

const getRecaptchaBadge = () =>
  typeof document !== 'undefined' &&
  document.getElementsByClassName('grecaptcha-badge')[0]

const getRecaptchaToken = () => {
  return new Promise(resolve => {
    if (typeof getRecaptchaBadge() === 'undefined') {
      resolve('error_token_undefined')
      return
    }
    window.grecaptcha.ready(function() {
      window.grecaptcha
        .execute(process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY, {
          action: 'GatsbyRegModalLayer',
        })
        .then(
          token => {
            resolve(token)
          },
          reason => {
            resolve(`error_token_${reason}`)
          }
        )
    })
  })
}

const showHideRecaptchaBadge = isHide => {
  if (
    typeof window !== 'undefined' &&
    typeof getRecaptchaBadge() !== 'undefined' &&
    window.grecaptcha
  ) {
    getRecaptchaBadge().style.display = isHide ? 'none' : 'block'
  }
}

export { attachRecaptchaScript, getRecaptchaToken, showHideRecaptchaBadge }
